import React from "react";
import { Link } from "react-router-dom";
import { FaShieldAlt } from "react-icons/fa";
import "./DataPrivacyReminderSection.css";

const DataPrivacyReminderSection = () => {
  return (
    <section className="_dPSect_o1A_">
      <div className="_dPCont_p2B_">
        {/* <div className="_pIWrap_r2B_"> 
          <FaShieldAlt className="_pIcon_s3C_" /> 
        </div> */}
        <h3 className="_hTitle_s5E_ features-title">Data Security & Privacy</h3>
        <p className="_pDesc_u5D_">
          Handle all customer and partner data{" "}
          <span className="_bold_desc_text_1Z_">confidentially</span>. Do not
          share sensitive info. For full privacy policy, see the{" "}
          <Link to="/sop" className="_pLink_v6D_">
            Standard Operating Procedures (SOP)
          </Link>
          .
        </p>
      </div>
    </section>
  );
};

export default DataPrivacyReminderSection;
